import BaseTrackContext from './context';
import type { VBaseTrackContextValue, VBaseTrackType } from './type';

const useVBaseProgressBar = <T extends VBaseTrackType>() =>
  BaseTrackContext.hook() as VBaseTrackContextValue<T>;

export default useVBaseProgressBar;
